import Button from '../../Button/Button.es.js';
import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { palette, fontSize } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Group } from '../../../primitives/Group/Group.es.js';
import { Text } from '../../Text/Text.es.js';

const StyledToggleFilterPopupButton = styled(Button)`
    color: ${({ hasSelected }) => hasSelected ? palette("neutral.0") : palette("neutral.400")};
    :hover {
        color: ${palette("neutral.0")};
    }
`;
const StyledGroupItem = styled(Group.Item)``;
const MobileToggleResponsiveMenuButtonWrapper = styled.div`
    display: flex;
`;
const MobileAppliedFiltersListItem = styled.button`
    font-size: ${fontSize("md")};
    color: ${palette("neutral.400")};
    display: flex;
    max-width: 60%;
    padding: 0;
    align-items: center;
    outline: none;
    svg {
        flex-shrink: 0;
    }
`;
const MobileAppliedFiltersListItemText = styled(Text)`
    display: block;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export { MobileAppliedFiltersListItem, MobileAppliedFiltersListItemText, MobileToggleResponsiveMenuButtonWrapper, StyledGroupItem, StyledToggleFilterPopupButton };
//# sourceMappingURL=Filter.es.js.map
